'use client'

import Script from 'next/script'
import { useEffect, useState } from 'react'

const GTM_ID = process.env.NEXT_PUBLIC_GTM_ID

export function GTMScript() {
  const [blocked, setBlocked] = useState(false)

  useEffect(() => {
    const consent = localStorage.getItem('cookie-consent')
    if (consent === 'rejected') {
      setBlocked(true)
    }

    const handleConsent = () => {
      const consent = localStorage.getItem('cookie-consent')
      setBlocked(consent === 'rejected')
    }
    window.addEventListener('cookie-consent-update', handleConsent)

    const handleStorage = (e: StorageEvent) => {
      if (e.key === 'cookie-consent') {
        setBlocked(e.newValue === 'rejected')
      }
    }
    window.addEventListener('storage', handleStorage)

    return () => {
      window.removeEventListener('cookie-consent-update', handleConsent)
      window.removeEventListener('storage', handleStorage)
    }
  }, [])

  if (!GTM_ID || blocked) return null

  return (
    <>
      {/* Google Tag Manager - Loads by default (opt-out model) */}
      <Script
        id="gtm-script"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: `
            (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
            'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
            })(window,document,'script','dataLayer','${GTM_ID}');
          `,
        }}
      />
    </>
  )
}

export function GTMNoScript() {
  const [blocked, setBlocked] = useState(false)

  useEffect(() => {
    const consent = localStorage.getItem('cookie-consent')
    if (consent === 'rejected') {
      setBlocked(true)
    }
  }, [])

  if (!GTM_ID || blocked) return null

  return (
    <noscript>
      <iframe
        src={`https://www.googletagmanager.com/ns.html?id=${GTM_ID}`}
        height="0"
        width="0"
        style={{ display: 'none', visibility: 'hidden' }}
      />
    </noscript>
  )
}

// Helper para enviar eventos
export function sendGTMEvent(eventName: string, eventParams?: Record<string, unknown>) {
  if (typeof window !== 'undefined' && window.dataLayer) {
    window.dataLayer.push({
      event: eventName,
      ...eventParams,
    })
  }
}

// Nota: dataLayer é declarado em src/lib/tracking.ts
